<script setup lang="ts">
import { AppHeader } from "@/modules/app-header";
import { AppMobileHeader } from "@/modules/app-mobile-header";
import { AppMobileNav } from "@/modules/app-mobile-nav";
import { AppFooter } from "@/modules/app-footer";
import { useWindowSize } from "@vueuse/core";

const { width } = useWindowSize();
</script>

<template>
  <AppHeader v-if="width > 1239" />

  <AppMobileHeader v-else />

  <RouterView />

  <AppFooter v-if="width > 1239" />

  <AppMobileNav v-else />
</template>
